import { queryClient } from '@core/Data/ReactQuery'
import { queryKeys } from '@core/Data/ReactQuery/constants'

export function invalidateKambiSpecials() {
  queryClient.invalidateQueries({
    refetchType: 'all',
    queryKey: queryKeys.kambiPlayerActiveRewards,
  })
}
